<template>
    <RouterLink v-bind="props" :to="computedTo"><slot></slot></RouterLink>
</template>

<script setup lang="ts">
import { useIntl } from '@/.shared/services/i18n/i18nservice';
import { computed} from 'vue';
import { RouterLink, type RouterLinkProps }  from 'vue-router'

const props = defineProps<RouterLinkProps>();
const i18n = useIntl();
const computedTo = computed(() => i18n.i18Route(props.to));


</script>